import Afloop from "afloop"
import Keyb from "keyb"


export default new class Loop {
    constructor() {
        this.EXPECTED_FRAMES_PER_SECOND = 60
        this.MAXIMUM_MILLISECONDS_PER_FRAME = 1000

        this.time = {
            "s": 0,
            "ms": 0,
            "f": 0,
        }
    }
    start(func) {
        return new Afloop((ms) => {
            ms = Math.min(ms, this.MAXIMUM_MILLISECONDS_PER_FRAME)

            // Calculate the delta in
            // different units of time.
            this.delta = {
                "ms": ms, // in milliseconds
                "s": ms / 1000, // in seconds
                "f": ms / (1000 / this.EXPECTED_FRAMES_PER_SECOND), // in frames
            }
            this.time.ms += this.delta.ms
            this.time.s += this.delta.s
            this.time.f += this.delta.f

            Keyb.delta = this.delta.ms

            func(this.delta)
        })
    }
}
